module.exports = __webpack_public_path__ + "static/billsbot-canada-5ba8b4cbc5810250c261e2004bddeebd.svg";